import { useUpdateUserSettings } from 'features/user';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar, Repeat } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenu,
  PopupMenuList,
  PopupMenuListItem,
  PopupMenuToggle,
} from 'shared/components/ui/popup-menu';
import { useUser } from 'shared/hooks/use-user';

export type MainContextMenuProps = {
  referenceElement?: React.RefObject<HTMLElement>;
  onClose: () => void;
};

export const MainContextMenu: React.FC<MainContextMenuProps> = ({
  referenceElement,
  onClose,
}) => {
  const { t } = useTranslation();
  const user = useUser();

  const updateUserSettings = useUpdateUserSettings();

  const toggleHideHabitsToday = () =>
    updateUserSettings({
      todayHideHabits: !user?.settings?.todayHideHabits,
    });
  const toggleHideExternalCalendarEvents = () =>
    updateUserSettings({
      todayHideDesktopExternalCalendarEvents:
        !user?.settings?.todayHideDesktopExternalCalendarEvents,
    });

  return (
    <PopupMenu
      referenceElement={referenceElement}
      position="bottom-end"
      onOutside={onClose}
    >
      <PopupMenuList hasBottomBorder>
        <PopupMenuListItem>
          <PopupMenuToggle
            start={<Icon icon={Repeat} />}
            label={t('pages.today.show-habits.label')}
            onChange={toggleHideHabitsToday}
            checked={!user?.settings?.todayHideHabits}
          />
        </PopupMenuListItem>

        <PopupMenuListItem>
          <PopupMenuToggle
            start={<Icon icon={Calendar} />}
            label={t('pages.today.show-external-calendars.label')}
            onChange={toggleHideExternalCalendarEvents}
            checked={!user?.settings?.todayHideDesktopExternalCalendarEvents}
          />
        </PopupMenuListItem>
      </PopupMenuList>
    </PopupMenu>
  );
};
